import { useState, useEffect as uEffect } from "react";
import "../chart.scss";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";



export default function EarnAreaChart({ aspect, title }){
  const [monthEarn, setMonthEarn] = useState("")
  const [monthEarn2, setMonthEarn2] = useState("");
  const [monthEarn3, setMonthEarn3] = useState("");
  const [monthEarn4, setMonthEarn4] = useState("");
  const [monthEarn5, setMonthEarn5] = useState("");
  const [monthEarn6, setMonthEarn6] = useState("");

  var currentDate = new Date(); // get the current date

  var dates = [];

  for (var i = 0; i < 6; i++) {
    // loop through the previous six months
    var previousMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i
    ); // get the date object for the previous month
    var monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    var previousMonthName = monthNames[previousMonth.getMonth()]; // get the name of the previous month
    var previousMonthYear = previousMonth.getFullYear(); // get the year of the previous month

    // if the previous month is in the previous year, subtract 1 from the year
    if (previousMonth.getMonth() > currentDate.getMonth()) {
      previousMonthYear -= 0;
    }

    var obj = { name: previousMonthName, Year: previousMonthYear }; // create an object with the name of the month and the year
    dates.push(obj); // add the object to the data array
  }



  uEffect(() => {
 fetch("http://localhost:8000/order/monthEarn", {
   method: "POST",
   headers: {
     "Content-Type": "application/json",
   }
 })
   .then((response) => response.json())
   .then((data) => setMonthEarn(data));

 fetch("http://localhost:8000/order/monthEarn2", {
   method: "POST",
   headers: {
     "Content-Type": "application/json",
   }
 })
   .then((response) => response.json())
   .then((data) => setMonthEarn2(data));

 fetch("http://localhost:8000/order/monthEarn3", {
   method: "POST",
   headers: {
     "Content-Type": "application/json",
   }
 })
   .then((response) => response.json())
   .then((data) => setMonthEarn3(data));

 fetch("http://localhost:8000/order/monthEarn4", {
   method: "POST",
   headers: {
     "Content-Type": "application/json",
   }
 })
   .then((response) => response.json())
   .then((data) => setMonthEarn4(data));

 fetch("http://localhost:8000/order/monthEarn5", {
   method: "POST",
   headers: {
     "Content-Type": "application/json",
   }
 })
   .then((response) => response.json())
   .then((data) => setMonthEarn5(data));

 fetch("http://localhost:8000/order/monthEarn6", {
   method: "POST",
   headers: {
     "Content-Type": "application/json",
   }
 })
   .then((response) => response.json())
   .then((data) => setMonthEarn6(data));

    
},[])


  const fetchedData = [
    { name: dates[5].name, Year: dates[5].Year, Total: monthEarn6 },
    { name: dates[4].name, Year: dates[4].Year, Total: monthEarn5 },
    { name: dates[3].name, Year: dates[3].Year, Total: monthEarn4 },
    { name: dates[2].name, Year: dates[2].Year, Total: monthEarn3 },
    { name: dates[1].name, Year: dates[1].Year, Total: monthEarn2 },
    { name: dates[0].name, Year: dates[0].Year, Total: monthEarn },
  ];
  return (
    <div className="chart">
      <div className="title">{title}</div>
      <ResponsiveContainer width="100%" aspect={aspect}>
        <AreaChart
          width={730}
          height={250}
          data={fetchedData}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id="Total" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#8884d8" stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="name" stroke="gray" />
          <YAxis dataKey="Total" stroke="gray" />
          <Tooltip />
          <CartesianGrid strokeDasharray="3 3" className="chartGrid" />
          <Area
            type="monotone"
            dataKey="Total"
            stroke="#8884d8"
            fillOpacity={1}
            fill="url(#Total)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
